export function LanguageSwitcher(): JSX.Element {
  return <></>;
}
